import PanAadhaarNotLinked from './panAadhaarNotLinkedBottomSheet/panAadhaarNotLinked'

const bottomSheetComponentMap = {
  PAN_AADHAAR_LINK_POPUP: {
    component: PanAadhaarNotLinked,
  },
}
export default bottomSheetComponentMap
